var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#f5f6fd"},attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer'),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }